/**
 * atomberg-etr.js
 * ─────────────────
 * Tab switching and keyboard navigation for the Explore the Range section.
 */
(function () {
  if (/** @type {any} */ (window)._atombergEtrInit) return;
  /** @type {any} */ (window)._atombergEtrInit = true;

  /**
   * Initialize one ETR section.
   * @param {HTMLElement} section
   */
  function init(section) {
    var tablist = /** @type {HTMLElement|null} */ (section.querySelector('.atomberg-etr__tabs'));
    if (!tablist) return;

    var pills = /** @type {NodeListOf<HTMLButtonElement>} */ (
      tablist.querySelectorAll('.atomberg-etr__pill')
    );
    if (!pills.length) return;

    /**
     * Activate a specific tab.
     * @param {string} tabId
     */
    function activateTab(tabId) {
      pills.forEach(function (pill) {
        var isActive = pill.getAttribute('data-tab-id') === tabId;
        pill.classList.toggle('atomberg-etr__pill--active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      section
        .querySelectorAll('.atomberg-etr__panel')
        .forEach(function (/** @type {Element} */ panel) {
          var isActive = panel.getAttribute('data-panel-id') === tabId;
          panel.classList.toggle('atomberg-etr__panel--hidden', !isActive);

          // Reset scroll position on the newly visible track
          if (isActive) {
            var track = /** @type {HTMLElement|null} */ (
              panel.querySelector('.atomberg-etr__track')
            );
            if (track) {
              track.scrollLeft = 0;
            }
          }
        });

      // Notify carousel arrows (and any other listeners) that the active panel changed
      section.dispatchEvent(
        new CustomEvent('atomberg:tab-change', {
          bubbles: true,
          detail: { tabId: tabId },
        })
      );
    }

    // Enable drag-to-scroll on all tracks in this section
    section.querySelectorAll('.atomberg-etr__track').forEach(function (el) {
      /** @type {any} */ (window).AtombergDragScroll.enable(el, {
        dragClass: 'atomberg-etr__track--dragging',
      });
    });

    // Tab click
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tabId = pill.getAttribute('data-tab-id');
        if (tabId) activateTab(tabId);
      });
    });

    // Keyboard navigation (left/right arrows within tablist)
    tablist.addEventListener('keydown', function (event) {
      var idx = Array.prototype.indexOf.call(pills, document.activeElement);
      if (idx === -1) return;

      /** @type {number|null} */
      var next = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (idx + 1) % pills.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (idx - 1 + pills.length) % pills.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = pills.length - 1;
      }

      if (next !== null) {
        event.preventDefault();
        var targetPill = pills[next];
        if (targetPill) {
          targetPill.focus();
          var tabId = targetPill.getAttribute('data-tab-id');
          if (tabId) activateTab(tabId);
        }
      }
    });
  }

  function start() {
    document.querySelectorAll('[data-atomberg-etr]').forEach(function (el) {
      init(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
